export default __webpack_public_path__ + "static/media/multi-sensory-design-template.c4cd7a46.pptx";